<template>
	<div class="print_container">
		<div class="popup_printBtn" style="justify-content:start;padding: 1% 0 0 1%;margin: 0 auto;">
			<button type="button" class="printBtn" @click="commonjs.winPrint()">출력</button>
		</div>
		<div v-for="(item, index) in items" :key="item.id" class="each_page">
			<img :src="`${SERVER_URL}${item?.file_path}/${item?.name}`" alt="덴탈클라우드 의뢰서" style="max-width:100%;">
		</div>
	</div>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

const today = moment().format('YYYY-MM-DD');

const props = defineProps({
	id: {
		type: Number,
		required: true
	},
});

const aiorder_ids = ref(props.id);

onMounted(async () => {
	const link = document.createElement('link');
	link.rel = 'stylesheet';
	link.href = '/css/print_imgs.css';
	document.head.appendChild(link);

	await getModels();
});

const items = ref([]);

const getModels = async () => {
	const params = new URLSearchParams();
	// params.append('mb_id', globaljs.mb_id);
	// params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('aiorder_ids', aiorder_ids.value);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder/imgs`, { params });
console.debug(response.data.result);
		items.value = response.data.result;

		setTimeout(() => {
			commonjs.winPrint();
		}, 500);
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>